'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataLayerConnectorFactory = undefined;

var _clientSide = require('../utils/clientSide');

var _constants = require('./constants');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var renderToStringScript = function renderToStringScript(dataLayerEventInfo) {
  return 'window.dataLayer.push(' + JSON.stringify(dataLayerEventInfo) + ');';
};

var dataLayerManagerFactory = function dataLayerManagerFactory() {
  var holdedDataLayer = [];

  return {
    getDataLayer: function getDataLayer() {
      var implementationToUse = holdedDataLayer;

      if ((0, _clientSide.isClientSide)()) {
        window.dataLayer = window.dataLayer || [];
        implementationToUse = window.dataLayer;
      }

      return implementationToUse;
    },
    flushHoldedData: function flushHoldedData() {
      var flushedDataLayer = holdedDataLayer.map(renderToStringScript);
      holdedDataLayer = [];

      return flushedDataLayer;
    }
  };
};

var dataLayerConnectorFactory = exports.dataLayerConnectorFactory = function dataLayerConnectorFactory() {
  var customDimensions = {};
  var dataLayerManager = dataLayerManagerFactory();

  var setCustomDimension = function setCustomDimension(payload) {
    Object.assign(customDimensions, payload);
  };

  var send = function send(payload) {
    dataLayerManager.getDataLayer().push(Object.assign({}, payload, customDimensions));
  };

  var flush = function flush() {
    var flushedData = dataLayerManager.flushHoldedData();

    return flushedData.length ? [_constants.INITIALIZE_DATALAYER].concat(_toConsumableArray(flushedData)).join('') : '';
  };

  return {
    send: send,
    setCustomDimension: setCustomDimension,
    flush: flush
  };
};

exports.default = {
  dataLayerConnectorFactory: dataLayerConnectorFactory
};
//# sourceMappingURL=dataLayer.js.map